module.exports = __webpack_public_path__ + "static/result_spidertown_wishmas-d19cb89f5acbaa2b8af986dda6a58fd0.jpg";